<template>
	<div class="border-bottom height-100 flex-centerize flex-column">
		<div class="title-text">Tailor your experience</div>
		<div class="title-text bold">What apps do you use?</div>
		<AnemicButton @click="$emit('open-add-apps')" tile class="pa-0 add-button mt-1">Add your apps</AnemicButton>
	</div>
</template>
<script>
export default { name: 'TailorYourExperience' };
</script>
<style lang="scss" scoped>
.border-bottom {
	border-bottom: 1px solid var(--border-color);
}
.add-button {
	width: 230px !important;
	height: 45px !important;
	font-size: 16px !important;
	border-radius: 10px !important;
	color: var(--white) !important;
	font-weight: normal !important;
	background: #605ed9 !important;
	letter-spacing: 0.21px !important;
}
.title-text {
	font-size: 18px;
	font-weight: normal;
	color: var(--primary-font-color);
	&.bold {
		font-weight: bold;
	}
}
</style>
